import React, { useEffect } from "react";
import { Dialog, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Body, Button, DialogContent, Divider, Label, SubTitle } from "../";
import {
  addCommaToEvery3Digits,
  changeLoadingType,
  changePackagingType,
  changeVehicleWeight,
  convertDate,
  convertOption,
} from "../../lib";
import { useFormContext } from "react-hook-form";

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 4,
    overflowY: "auto",
  },
  dialogContainer: {
    paddingTop: 32,
    paddingLeft: 20,
    paddingBottom: 20,
    paddingRight: 20,
  },

  listContainer: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    marginBottom: 18,
  },
  listRow: {
    display: "flex",
    marginTop: 12,
  },
  listRow2: {
    display: "flex",
    marginTop: 6,
  },
  listLabel: {
    width: 90,
    flexShrink: 0,
  },
  button: {
    width: 100,
    height: 33,
    fontSize: 13,
  },
  shortMessage: {
    color: "red",
    textAlign: "center",
    fontWeight: "bold",
  },
}));

const EstimateInfo = (props: any) => {
  const classes = useStyles();
  const { estimatedDistance, estimatedDuration, estimatedCharge } = props;

  if (estimatedDistance && estimatedDuration) {
    const distance = estimatedDistance / 1000;
    const hour = estimatedDuration / 60;
    const minute = estimatedDuration % 60;

    let duration = "";
    if (hour > 0) {
      duration += `${Math.floor(hour)}시간 ${minute.toFixed(0)}분`;
    } else {
      duration += `${minute}분`;
    }

    return (
      <>
        <li className={classes.listRow}>
          <span className={classes.listLabel}>
            <Label>{"예상 거리"}</Label>
          </span>
          <Body>{distance} km</Body>
        </li>
        <li className={classes.listRow}>
          <span className={classes.listLabel}>
            <Label>{"예상 시간"}</Label>
          </span>
          <Body>{duration}</Body>
        </li>
        <li className={classes.listRow}>
          <span className={classes.listLabel}>
            <Label>{"예상 운송료"}</Label>
          </span>
          <Body>
            {estimatedCharge === 0
              ? "미정"
              : addCommaToEvery3Digits(estimatedCharge || 0) + "원"}
          </Body>
        </li>
      </>
    );
  } else {
    return <></>;
  }
};

export default function OrderCheck(props: any) {
  const classes = useStyles();
  const { order, cancel, sendOrder, sendingOrder, orderer } = props;

  const { watch } = useFormContext();

  const userInputTime =
    (order.arrival.date.getTime() - order.departure.date.getTime()) /
    (1000 * 60); //사용자 요청시간간격 분단위
  const durationTime = (order.estimatedDuration / 1.1) * 0.7; //데드라인 분 단위

  let isTimeTooShort = false;

  if (durationTime > 120 && userInputTime < durationTime) {
    //사용자 요청시간이 실배차의 70% 이하면서 실운행시간 2시간이하.
    isTimeTooShort = true;
  }

  console.log(
    "order.departure.date:",
    order.departure.date,
    typeof order.departure.date
  );
  useEffect(() => {
    console.log(order);
    if (order) {
      console.log("운송주문확인 - Modal ON::");

      window.gtag("event", `운송주문-확인모달-ON`, {
        user_id: localStorage.getItem("customerName") || "none",
      });
    }
  }, [order]);

  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth={"lg"}
      aria-labelledby="confirmation-dialog-title"
      open={true}
      onClose={cancel}
    >
      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={1} className={classes.dialogContainer}>
          <Grid item>
            <Grid container direction={"column"} spacing={1}>
              <Grid item>
                <SubTitle>{"출발지"}</SubTitle>
                <ul className={classes.listContainer}>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"장소명"}</Label>
                    </span>
                    <Body>{order.departure.name}</Body>
                  </li>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"주소"}</Label>
                    </span>
                    <Body>
                      {order.departure.addressBase +
                        " " +
                        order.departure.addressDetail}
                    </Body>
                  </li>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"연락처"}</Label>
                    </span>
                    <Body>{order.departure.phone}</Body>
                  </li>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"날짜/시간"}</Label>
                    </span>
                    <Body>{convertDate(order.departure.date)}</Body>
                  </li>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"특이사항"}</Label>
                    </span>
                    <Body>{order.departure.placeInfoForCustomer}</Body>
                  </li>
                </ul>
              </Grid>
              {console.log(watch("waypoint0"))}
              {watch("waypoint0") && (
                <Grid item>
                  <SubTitle>{"경유지"}</SubTitle>
                  <ul className={classes.listContainer}>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"장소명"}</Label>
                      </span>
                      <Body>{order.waypoint0.name}</Body>
                    </li>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"주소"}</Label>
                      </span>
                      <Body>
                        {order.waypoint0.addressBase +
                          " " +
                          order.departure.addressDetail}
                      </Body>
                    </li>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"연락처"}</Label>
                      </span>
                      <Body>{order.waypoint0.phone}</Body>
                    </li>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"날짜/시간"}</Label>
                      </span>
                      <Body>{convertDate(order.waypoint0.date)}</Body>
                    </li>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"메모"}</Label>
                      </span>
                      <Body>{order.waypoint0.memo}</Body>
                    </li>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"특이사항"}</Label>
                      </span>
                      <Body>{order.waypoint0.placeInfoForCustomer}</Body>
                    </li>
                  </ul>
                </Grid>
              )}

              {watch("waypoint1") && (
                <Grid item>
                  <SubTitle>{"경유지"}</SubTitle>
                  <ul className={classes.listContainer}>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"장소명"}</Label>
                      </span>
                      <Body>{order.waypoint1.name}</Body>
                    </li>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"주소"}</Label>
                      </span>
                      <Body>
                        {order.waypoint1.addressBase +
                          " " +
                          order.departure.addressDetail}
                      </Body>
                    </li>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"연락처"}</Label>
                      </span>
                      <Body>{order.waypoint1.phone}</Body>
                    </li>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"날짜/시간"}</Label>
                      </span>
                      <Body>{convertDate(order.waypoint1.date)}</Body>
                    </li>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"메모"}</Label>
                      </span>
                      <Body>{order.waypoint1.memo}</Body>
                    </li>
                    <li className={classes.listRow2}>
                      <span className={classes.listLabel}>
                        <Label>{"특이사항"}</Label>
                      </span>
                      <Body>{order.waypoint1.placeInfoForCustomer}</Body>
                    </li>
                  </ul>
                </Grid>
              )}

              <Grid item>
                <SubTitle>{"도착지"}</SubTitle>
                <ul className={classes.listContainer}>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"장소명"}</Label>
                    </span>
                    <Body>{order.arrival.name}</Body>
                  </li>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"주소"}</Label>
                    </span>
                    <Body>
                      {order.arrival.addressBase +
                        " " +
                        order.arrival.addressDetail}
                    </Body>
                  </li>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"연락처"}</Label>
                    </span>
                    <Body>{order.arrival.phone}</Body>
                  </li>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"날짜/시간"}</Label>
                    </span>
                    <Body>{convertDate(order.arrival.date)}</Body>
                  </li>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"특이사항"}</Label>
                    </span>
                    <Body>{order.arrival.placeInfoForCustomer}</Body>
                  </li>
                </ul>
                <Divider />
              </Grid>
              <Grid item>
                <SubTitle>{"운송정보"}</SubTitle>
                <ul className={classes.listContainer}>
                  <li className={classes.listRow}>
                    <span className={classes.listLabel}>
                      <Label>{"요청 차량"}</Label>
                    </span>
                    <Body>
                      {order.vehicleType} /{" "}
                      {changeVehicleWeight(
                        order.vehicleType,
                        order.vehicleWeight
                      )}
                    </Body>
                  </li>
                  <li className={classes.listRow}>
                    <span className={classes.listLabel}>
                      <Label>{"품목"}</Label>
                    </span>
                    <Body>
                      {order.item}{" "}
                      {order.vehicleType !== "오토바이" &&
                        order.totalLength > 0 &&
                        ` / ${order.totalLength}M`}{" "}
                      {order.vehicleType !== "오토바이" &&
                        ` / ${order.totalWeight}톤`}{" "}
                    </Body>
                  </li>
                  <li className={classes.listRow}>
                    <span className={classes.listLabel}>
                      <Label>{"포장방법"}</Label>
                    </span>
                    <Body>{changePackagingType(order.packagingType)}</Body>
                  </li>
                  <li className={classes.listRow}>
                    <span className={classes.listLabel}>
                      <Label>{"상차/하차 방법"}</Label>
                    </span>
                    <Body>
                      {changeLoadingType(order.loadingType)} /{" "}
                      {changeLoadingType(order.unloadingType)}
                    </Body>
                  </li>
                  <li className={classes.listRow}>
                    <span className={classes.listLabel}>
                      <Label>{"옵션"}</Label>
                    </span>
                    <Body>
                      {convertOption(
                        order.optionBackDoorOpen,
                        order.optionForklift,
                        order.optionShuttle,
                        order.optionMultiple,
                        order.orderCount,
                        order.orderInterval,
                        order.optionMixedLoading,
                        order.optionCashOnDelivery
                      )}
                    </Body>
                  </li>
                  <li className={classes.listRow}>
                    <span className={classes.listLabel}>
                      <Label>{"기사님 요청 사항"}</Label>
                    </span>
                    <Body>{order.requestNoteForDriver}</Body>
                  </li>
                  <li className={classes.listRow}>
                    <span className={classes.listLabel}>
                      <Label>{"카고콜 요청 사항"}</Label>
                    </span>
                    <Body>{order.requestNoteForAdmin}</Body>
                  </li>

                  <EstimateInfo
                    estimatedDistance={order.estimatedDistance}
                    estimatedDuration={order.estimatedDuration}
                    estimatedCharge={order.estimatedCharge}
                  />
                </ul>
              </Grid>
              <Grid item>
                <SubTitle>{"담당자 정보"}</SubTitle>
                <ul className={classes.listContainer}>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"담당자명"}</Label>
                    </span>
                    <Body>{orderer.name}</Body>
                  </li>
                  <li className={classes.listRow2}>
                    <span className={classes.listLabel}>
                      <Label>{"연락처"}</Label>
                    </span>
                    <Body>{orderer.phone}</Body>
                  </li>
                  <li>
                    {isTimeTooShort && (
                      <p className={classes.shortMessage}>
                        도착지 설정 시간보다 늦게 도착할 수 있습니다.
                      </p>
                    )}
                  </li>
                </ul>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction={"row"}
                  justifyContent={"center"}
                  spacing={3}
                >
                  <Grid item>
                    <Button
                      disabled={sendingOrder}
                      color={"secondary"}
                      className={classes.button}
                      onClick={cancel}
                    >
                      취소
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      disabled={sendingOrder}
                      className={classes.button}
                      onClick={sendOrder}
                    >
                      주문
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
